"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Table_1 = require("@sportnet/ui/lib/Table");
var react_1 = tslib_1.__importDefault(require("react"));
var Column_1 = tslib_1.__importDefault(require("./Column"));
var elements_1 = require("./elements");
var Header_1 = tslib_1.__importDefault(require("./Header"));
var Table = function (_a) {
    var _b;
    var _c = _a.data, data = _c === void 0 ? {} : _c, renderEmpty = _a.renderEmpty;
    if (renderEmpty && !data.title && (((_b = data.table) === null || _b === void 0 ? void 0 : _b.length) || 0) < 1) {
        return react_1["default"].createElement(react_1["default"].Fragment, null, renderEmpty('table'));
    }
    var header = data.header || [];
    var table = data.table || [];
    return (react_1["default"].createElement("div", { className: "content-widget-table" },
        react_1["default"].createElement(Table_1.Table, null,
            data.title && react_1["default"].createElement(Header_1["default"], null, data.title),
            header.includes('t') && (react_1["default"].createElement(Table_1.Thead, null,
                react_1["default"].createElement(elements_1.Tr, null, table[0].map(function (col, colIndex) {
                    if (header.includes('l') && colIndex === 0) {
                        return (react_1["default"].createElement(elements_1.LeftTh, { key: colIndex + "-" + col, dangerouslySetInnerHTML: { __html: col } }));
                    }
                    return (react_1["default"].createElement(elements_1.Th, { key: colIndex + "-" + col, dangerouslySetInnerHTML: { __html: col } }));
                })))),
            react_1["default"].createElement(Table_1.Tbody, null, table.map(function (row, rowIdx) {
                if (rowIdx === 0 && header.includes('t')) {
                    return null;
                }
                return (react_1["default"].createElement(elements_1.Tr, { key: rowIdx + "-" + row }, row.map(function (col, colIndex) { return (react_1["default"].createElement(Column_1["default"], { key: colIndex + "-" + col, col: col, colIndex: colIndex, header: data.header })); })));
            })))));
};
exports["default"] = react_1["default"].memo(Table);
